document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-mobile-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', () => {
      const open = mobileNav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  const toast = document.getElementById('VelaroToast');
  let toastTimer;
  const showToast = (message) => {
    if (!toast) return;
    window.clearTimeout(toastTimer);
    toast.textContent = message;
    toast.classList.add('is-visible');
    toastTimer = window.setTimeout(() => toast.classList.remove('is-visible'), 2400);
  };

  async function refreshCartCount() {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
        headers: { 'Accept': 'application/json' }
      });
      if (!response.ok) return;
      const cart = await response.json();
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
      });
    } catch (error) {
      // El carrito seguirá funcionando aunque no pueda refrescarse el contador.
    }
  }

  document.querySelectorAll('form[data-type="ajax-add"]').forEach(form => {
    form.addEventListener('submit', async (event) => {
      const submitter = event.submitter;

      // Los botones dinámicos de Shopify (Shop Pay, Google Pay, etc.) deben
      // conservar su flujo nativo y no pasar por el agregado AJAX al carrito.
      if (
        submitter &&
        (submitter.classList.contains('shopify-payment-button__button') ||
          submitter.closest('.shopify-payment-button') ||
          submitter.closest('[data-shopify="payment-button"]'))
      ) {
        return;
      }

      event.preventDefault();

      const button = submitter || form.querySelector('[type="submit"]');
      if (!button || button.disabled) return;

      const original = button.textContent;
      button.disabled = true;
      button.textContent = 'Agregando…';

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        });

        if (!response.ok) throw new Error('No se pudo agregar');

        await refreshCartCount();
        showToast('Agregado al carrito');
        button.textContent = 'Agregado';
        window.setTimeout(() => {
          button.textContent = original;
        }, 1200);
      } catch (error) {
        showToast('No fue posible agregar el producto');
        button.textContent = original;
      } finally {
        button.disabled = false;
      }
    });
  });
});
